import util from '../util'

let controller = 'ParamGlobal'
export default Object.assign({}, util.GetCrud(controller, null), {
})
